export default "__VITE_ASSET__CZhFzl9K__"